import React, { useMemo } from 'react';
import BannerLayout from '../../components/BannerLayout';
import Typography from '../../components/Typography';
import usePersonalData, { PersonalDataField } from '../../hooks/personalData.hooks';
import { translate } from '../../i18n';
import { useAuthentication } from '../../state/Authentication';
import ACardWidget from './ACardWidget';
import AccessKeysWidget from './AccessKeysWidget';
import ECounterWidget from './ECounterWidget';
import ExternalLinksWidget from './ExternalLinksWidget';
import MySettingsWidget from './MySettingsWidget';
import PersonalDataWidget from './PersonalDataWidget';
import './style.scss';

interface DashboardProps {}

const Dashboard: React.FC<DashboardProps> = () => {
  const { state } = useAuthentication();
  const { user } = state;

  const { humanReadableData: personalData } = usePersonalData(state, [
    PersonalDataField.FIRST_NAME,
    PersonalDataField.LAST_NAME,
    PersonalDataField.NICKNAME,
    PersonalDataField.BIRTH_DATE,
  ]);

  const welcomeText = useMemo(() => {
    return user.nickname || user.firstName
      ? translate('dashboard.welcome.name', {
          name: user.nickname || user.firstName,
        })
      : translate('dashboard.welcome');
  }, [user]);

  return (
    <BannerLayout
      title={welcomeText}
      metaTitle="dashboard.title"
      metaDescription={'dashboard.description'}
    >
      <main id="main-content" className="col-xs-12 ckp-o-dashboard__main" role="main">
        <div className="row">
          <Typography classNames="ckp-o-dashboard__main__description col-xs-12 u-margin-bottom">
            {translate('dashboard.description')}
          </Typography>

          <AccessKeysWidget classNames="ckp-o-dashboard__main__widget col-xs-12 col-lg-6 col-xl-4" />

          <PersonalDataWidget
            data={personalData}
            classNames="ckp-o-dashboard__main__widget col-xs-12 col-lg-6 col-xl-4"
          />

          <ACardWidget
            card={user.acard}
            classNames="ckp-o-dashboard__main__widget col-xs-12 col-lg-6 col-xl-4"
          />

          <ECounterWidget classNames="ckp-o-dashboard__main__widget col-xs-12 col-lg-6 col-xl-4" />

          <MySettingsWidget classNames="ckp-o-dashboard__main__widget col-xs-12 col-lg-6 col-xl-4" />

          <ExternalLinksWidget classNames="ckp-o-dashboard__main__widget col-xs-12 col-lg-6 col-xl-4" />
        </div>
      </main>
    </BannerLayout>
  );
};

export default Dashboard;
